export default __webpack_public_path__ + "static/media/nba.e68bca9b.svg";